export default __webpack_public_path__ + "static/media/4.efa4cc60.webp";